import React from 'react';
import Logo from './Logo';

const MobileAppInstructions: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Logo />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Password Reset Successful!
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Your password has been successfully updated.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
              <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              Next Steps
            </h3>
            
            <div className="text-left space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h4 className="text-sm font-medium text-blue-900 mb-2">
                  📱 Log into the Deal Once Mobile App
                </h4>
                <p className="text-sm text-blue-700">
                  Use your updated password to log into the Deal Once mobile app on your device.
                </p>
              </div>
              
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <h4 className="text-sm font-medium text-gray-900 mb-2">
                  🔐 Your Account is Secure
                </h4>
                <p className="text-sm text-gray-600">
                  Your password has been successfully updated and your account is now secure.
                </p>
              </div>
              
            </div>
            
            <div className="mt-6">
              <button
                onClick={() => window.close()}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Close This Window
              </button>
            </div>
            
            <div className="mt-4">
              <p className="text-xs text-gray-500">
                If you need assistance, please contact support.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppInstructions;
